(() => {
  const rules = [
    { selector: '.tga-home-hero', property: '--hero-scale', tabletBase: 1920 },
    { selector: '.tga-choose-lima', property: '--tga-choose-scale', tabletBase: 1920 },
    { selector: '.tga-compare-lima', property: '--tga-compare-scale', tabletBase: 1280 },
    { selector: '.tga-every-detail', property: '--tga-detail-scale', tabletBase: 1280 },
    { selector: '.tga-meet-lima-tabs', property: '--tga-meet-scale', tabletBase: 1280 },
    { selector: '.tga-oopsie-cards', property: '--tga-oopsie-scale', tabletBase: 1280 },
    { selector: '.tga-origin-tabs', property: '--tga-origin-scale', tabletBase: 1280 },
    { selector: '.tga-product-builder', property: '--tga-builder-scale', tabletBase: 991 },
    { selector: '.tga-professionals-say', property: '--tga-professionals-scale', tabletBase: 1440, mobileBase: 390 },
    { selector: '.tga-social-reels', property: '--tga-social-scale', tabletBase: 1280 },
    { selector: '.tga-404', property: '--tga-404-scale', fixedBase: 1920, clampDesktop: true },
  ];

  let frameId = 0;

  function getBase(rule, viewportWidth) {
    if (rule.fixedBase) return rule.fixedBase;
    if (viewportWidth <= 767) return rule.mobileBase || 393;
    if (viewportWidth <= 991) return rule.tabletBase;
    if (viewportWidth <= 1280) return rule.tabletBase === 1440 ? 1440 : 1280;
    if (viewportWidth <= 1440) return 1440;
    return 1920;
  }

  function updateScales() {
    frameId = 0;
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth;

    rules.forEach((rule) => {
      const base = getBase(rule, viewportWidth);
      const effectiveWidth = rule.clampDesktop ? Math.min(viewportWidth, base) : viewportWidth;
      const value = String(effectiveWidth / base);

      document.querySelectorAll(rule.selector).forEach((element) => {
        element.style.setProperty(rule.property, value);
      });
    });

    const header = document.querySelector('.tga-header');
    if (header) {
      const headerBase = viewportWidth <= 991 ? 1280 : viewportWidth <= 1280 ? 1280 : viewportWidth <= 1440 ? 1440 : 1920;
      document.documentElement.style.setProperty('--tga-header-scale', String(viewportWidth / headerBase));
    }
  }

  function scheduleUpdate() {
    if (frameId) return;
    frameId = window.requestAnimationFrame(updateScales);
  }

  updateScales();
  document.addEventListener('DOMContentLoaded', updateScales, { once: true });
  document.addEventListener('shopify:section:load', updateScales);
  window.addEventListener('resize', scheduleUpdate, { passive: true });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', scheduleUpdate, { passive: true });
  }
})();
